module.exports = __webpack_public_path__ + "img/cross.d2e67638.svg";